import React from 'react';
import HeroSection from '../../components/home/HeroSection';
import FeaturedServices from '../../components/home/FeaturedServices';
import ContactCTA from '../../components/home/ContactCTA';

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <FeaturedServices />
      <ContactCTA />
    </div>
  );
};

export default HomePage;
